import React from 'react';
import * as Portal from '@radix-ui/react-portal';

type CuratedEngagementShortcutProps = {
  onClick: () => void;
}

const CuratedEngagementShortcut = ({ onClick }: CuratedEngagementShortcutProps) => {
  return (
    <Portal.Root>
      <div
        className="invisible xl:visible fixed bottom-12 right-4 z-50 flex flex-col space-y-[0.38rem] p-4 pb-6 rounded border-[#D9A0A7] bg-[#F5D7DB] text=[#6D2C35] max-w-[10.375rem]"
        onClick={onClick}
        role="button"
        tabIndex={0}
        aria-label="Get help creating your Huddle request"
        aria-modal="true"
      >
        <h3 className="text-2xl">Not sure?</h3>
        <p className="text-xs">Get help creating your Huddle request. →</p>
      </div>
    </Portal.Root>
  )
}

export default CuratedEngagementShortcut;
